import { Timeseries } from "@fiberplane/prometheus-query";

export { useNotificationSettings } from "./useNotificationSettings";
export { useNavigateToAlerts } from "./useNavigateToAlerts";
export { getServiceWorker, hasServiceWorkerSupport } from "./setup";
export type CoreAlertInfo = Pick<Timeseries, "name" | "attributes" | "labels">;
export type { NotificationSettings } from "./useNotificationSettings";
